import React, { useMemo } from 'react';
import { DisplayLink } from '@xo-union/tk-ui-links';
import QuestionSubText from './QuestionSubText';
import { EventType } from '../WeddingPageCard/EventItem';
import styles from './styles.scss';
import { EventRsvpDataQuery } from '../../generated/graphql';

interface Props {
  event: EventType;
  isPrivateRsvp: boolean | null;
  guestCount: number;
  rsvpData: NonNullable<NonNullable<EventRsvpDataQuery['eventRsvpData']>[0]>[] | null;
}

const AddGuestText: React.FC<Props> = ({ event, isPrivateRsvp, guestCount, rsvpData }) => {
  const totalGuestCount: number = useMemo(() => {
    const total = rsvpData?.reduce((acc, eventRsvpData) => {
      return acc + (eventRsvpData?.guestCount || 0);
    }, 0);
    return total || 0;
  }, [rsvpData]);

  return (
    <>
      <QuestionSubText
        eventLink={`/our-guest-list?event=${event.id}`}
        eventName={event.name || undefined}
        guestCount={guestCount}
        privateRsvp={isPrivateRsvp}
        hasQuestions={!!event?.questions && !!event?.questions.length}
      />
      {isPrivateRsvp && (totalGuestCount === 0 || guestCount === 0) && (
        <DisplayLink
          as="a"
          href={
            totalGuestCount === 0
              ? `/our-guest-list/import-spreadsheet?referrerRedirectPath=/gs/dashboard&event=${event.id}`
              : '/our-guest-list?event=all'
          }
          className={`${styles.marginLeftSm} ${styles.clickable}`}
          data-testid={`AddGuest-${event.name}`}
        >
          + Add Guest
        </DisplayLink>
      )}
    </>
  );
};

export default AddGuestText;
